import React from 'react';
import { Link } from 'react-router-dom';
import { useNotifications } from '../contexts/NotificationsContext';
import './StaleEmbeddingBanner.css';

/**
 * Project-level warning when ingested data is newer than the last embedding
 * (or search tools have never been embedded). Surfaces Bug 157 class failures
 * where Sheet sync updates rows but Search stays short until Initiate Embedding.
 */
function StaleEmbeddingBanner() {
  const { embeddingNeededCount, embeddingSources } = useNotifications();

  if (!embeddingNeededCount || embeddingNeededCount <= 0) return null;

  const staleSources = (embeddingSources || []).filter((s) => s.reason === 'stale_ingestion');
  const neverEmbedded = (embeddingSources || []).filter((s) => s.reason === 'never_embedded');
  const isStale = staleSources.length > 0;
  const toolNames = (isStale ? staleSources : neverEmbedded.length ? neverEmbedded : embeddingSources)
    .map((s) => s.name || s.slug)
    .filter(Boolean)
    .slice(0, 3);
  const extra = Math.max(0, embeddingNeededCount - toolNames.length);
  const toolsLabel = toolNames.length
    ? `${toolNames.join(', ')}${extra > 0 ? ` (+${extra} more)` : ''}`
    : `${embeddingNeededCount} search tool${embeddingNeededCount === 1 ? '' : 's'}`;

  return (
    <div className="stale-embedding-banner" role="status">
      <div className="stale-embedding-banner-text">
        <i className="fas fa-triangle-exclamation" aria-hidden="true" />
        <span>
          {isStale
            ? 'Data was ingested after the last embedding. Search results may be incomplete until you re-embed.'
            : 'Search tools need embedding before results will include your ingested data.'}
          {' '}
          Affected: {toolsLabel}.
        </span>
      </div>
      <Link to="/horizon/data-embeddings" className="stale-embedding-banner-link">
        Open Data Embeddings
      </Link>
    </div>
  );
}

export default StaleEmbeddingBanner;
